import React, { Component } from 'react';
import { List, Datagrid, TextField, EditButton, RichTextField } from 'react-admin';

export default class NeighborhoodsList extends Component {
    render() {
        return (
            <List {...this.props}>
                <Datagrid>
                    <TextField source="name" label="Nombre" />
                    <RichTextField source="description" stripTags />
                    <EditButton label="" />
                </Datagrid>
            </List>
        )
    }
};